


























import Vue from 'vue'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import HiddenPhonesAlert from '~/components/car/classifieds/form/fieldsets/handlers/partials/HiddenPhonesAlert.vue'
import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'

export default Vue.extend({
  components: { Fieldset, HiddenPhonesAlert },
  mixins: [BaseFieldsetMixin],
  computed: {
    ...mapState(CLASSIFIED_FORM_NS, {
      fieldValues: state => state.fieldValues
    }),
    ...mapGetters(CLASSIFIED_FORM_NS, {
      getFieldValueByName: 'getFieldValueByName'
    }),
    allPhonesAreHidden() {
      const telephone1 = this.fieldValues.telephone1
      const telephone2 = this.fieldValues.telephone2

      const filledTelephones = [telephone1, telephone2].filter(
        tel => tel?.telephone
      )
      if (filledTelephones.length === 0) {
        return false
      }
      return filledTelephones.every(tel => tel.dont_show_to_public)
    }
  }
})
